import { useEffect } from 'react'

import { Box, Button, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useSyncValidation } from 'modules/integrations/hooks/SyncContext/useSyncValidation'

import Unavailable from './Unavailable'

interface Props {
  integrationName: string
  onSync: () => Promise<void>
  syncing: boolean
}

const Pending = ({ integrationName, onSync, syncing }: Props) => {
  const { configuration } = usePrivateIntegrationsSyncContext()
  const { fetchIssues, issues, issuesLoading } = useSyncValidation()

  useEffect(() => {
    fetchIssues()
  }, [fetchIssues])

  if (issuesLoading) {
    return (
      <Box width="full" alignItems="center" justifyContent="center">
        <Spinner />
      </Box>
    )
  }

  if (issues.length > 0) {
    return <Unavailable issues={issues} />
  }

  return (
    <Box
      background="grey200"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{ all: 'abs008' }}
      gap="s16"
    >
      <Text.Header2>
        {i18n.t('payroll_integrations.employee_update_leave.pending.title', {
          integration_name: integrationName,
        })}
      </Text.Header2>
      {i18n.t('payroll_integrations.employee_update_leave.pending.message', {
        integration_name: integrationName,
      })}
      <Button onClick={onSync} disabled={syncing}>
        {i18n.t('payroll_integrations.employee_update_leave.pending.submit', {
          integration_name: integrationName,
          entity_name: configuration.syncableEntityName(),
        })}
      </Button>
    </Box>
  )
}

export default Pending
